export default "__VITE_ASSET__BgdRoiO9__"